import { Navigate, Outlet, useSearchParams } from "react-router";
import { usePlatformAuth } from "../context/platform-auth";

export function RequirePlatformGuest() {
	const { user, loading } = usePlatformAuth();
	const [searchParams] = useSearchParams();
	const redirect = searchParams.get("redirect") || "/workspaces";

	if (loading) return null;
	if (user) return <Navigate to={redirect} replace />;
	return <Outlet />;
}
